function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable react/sort-comp */
/* TODO(csilvers): fix these lint errors (http://eslint.org/docs/rules): */
/* To fix, remove an entry above, run ka-lint, and fix errors. */
var React = require("react");
var TeX = require("react-components/tex.jsx");

var ButtonGroup = require("react-components/button-group.jsx");

var _require = require("../../mixins/changeable.jsx"),
    ChangeableProps = _require.ChangeableProps,
    change = _require.change;

var MathInput = require("../../components/math-input.jsx");
var NumberInput = require("../../components/number-input.jsx");

var ConstraintEditor = function (_React$Component) {
    _inherits(ConstraintEditor, _React$Component);

    function ConstraintEditor() {
        var _temp, _this, _ret;

        _classCallCheck(this, ConstraintEditor);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), _possibleConstructorReturn(_this, _ret);
    }

    ConstraintEditor.prototype.render = function render() {
        return React.createElement(
            "div",
            null,
            React.createElement(
                "div",
                { className: "perseus-widget-row" },
                "Constraint:",
                " ",
                React.createElement(ButtonGroup, {
                    value: this.props.constraint,
                    allowEmpty: false,
                    buttons: [{ value: "none", content: "None" }, { value: "snap", content: "Snap" }, { value: "x", content: "x=" }, { value: "y", content: "y=" }],
                    onChange: this.change("constraint")
                })
            ),
            this.props.constraint === "snap" && React.createElement(
                "div",
                { className: "perseus-widget-row" },
                "Snap:",
                " ",
                React.createElement(NumberInput, {
                    value: this.props.snap,
                    placeholder: 0,
                    onChange: this.change("snap")
                })
            ),
            this.props.constraint === "x" && React.createElement(
                "div",
                { className: "graph-settings" },
                React.createElement(
                    "div",
                    { className: "perseus-widget-row" },
                    React.createElement(
                        TeX,
                        null,
                        "x="
                    ),
                    " ",
                    React.createElement(MathInput, {
                        buttonSets: [],
                        buttonsVisible: "never",
                        value: this.props.constraintFn,
                        onChange: this.change("constraintFn")
                    })
                )
            ),
            this.props.constraint === "y" && React.createElement(
                "div",
                { className: "graph-settings" },
                React.createElement(
                    "div",
                    { className: "perseus-widget-row" },
                    React.createElement(
                        TeX,
                        null,
                        "y="
                    ),
                    " ",
                    React.createElement(MathInput, {
                        buttonSets: [],
                        buttonsVisible: "never",
                        value: this.props.constraintFn,
                        onChange: this.change("constraintFn")
                    })
                )
            ),
            "Ensure these are set so nothing can be dragged off the canvas:",
            React.createElement(
                "div",
                { className: "perseus-widget-row" },
                React.createElement(
                    "div",
                    { className: "perseus-widget-row" },
                    React.createElement(
                        TeX,
                        null,
                        "x \\in \\Large["
                    ),
                    " ",
                    React.createElement(MathInput, {
                        buttonSets: [],
                        buttonsVisible: "never",
                        value: this.props.constraintXMin,
                        onChange: this.change("constraintXMin")
                    }),
                    React.createElement(
                        TeX,
                        null,
                        ", "
                    ),
                    " ",
                    React.createElement(MathInput, {
                        buttonSets: [],
                        buttonsVisible: "never",
                        value: this.props.constraintXMax,
                        onChange: this.change("constraintXMax")
                    }),
                    " ",
                    React.createElement(
                        TeX,
                        null,
                        "\\Large]"
                    )
                )
            ),
            React.createElement(
                "div",
                { className: "perseus-widget-row" },
                React.createElement(
                    "div",
                    { className: "perseus-widget-row" },
                    React.createElement(
                        TeX,
                        null,
                        "y \\in \\Large["
                    ),
                    " ",
                    React.createElement(MathInput, {
                        buttonSets: [],
                        buttonsVisible: "never",
                        value: this.props.constraintYMin,
                        onChange: this.change("constraintYMin")
                    }),
                    React.createElement(
                        TeX,
                        null,
                        ", "
                    ),
                    " ",
                    React.createElement(MathInput, {
                        buttonSets: [],
                        buttonsVisible: "never",
                        value: this.props.constraintYMax,
                        onChange: this.change("constraintYMax")
                    }),
                    " ",
                    React.createElement(
                        TeX,
                        null,
                        "\\Large]"
                    )
                )
            )
        );
    };

    return ConstraintEditor;
}(React.Component);

ConstraintEditor.defaultProps = {
    constraint: "none",
    snap: 0.5,
    constraintFn: "0",
    constraintXMin: "-10",
    constraintXMax: "10",
    constraintYMin: "-10",
    constraintYMax: "10"
};

var _initialiseProps = function _initialiseProps() {
    var _this2 = this;

    this.change = function () {
        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
        }

        return change.apply(_this2, args);
    };
};

module.exports = ConstraintEditor;


/*****************
 ** WEBPACK FOOTER
 ** ./src/widgets/interaction/constraint-editor.jsx
 ** module id = 291
 ** module chunks = 0 1
 **/